import { useCallback, useEffect, useMemo, useRef } from 'react';
import useSearchFilter from './useSearchFilter';

export enum SEARCH_FILER_REF_TYPE {
  CATEGORY = 0,
  COLOR = 1,
  PRICE = 2,
  DELIVERY = 3,
}

/**
 * 검색필터에서 특정 영역으로 스크롤 이동되도록 dom 을 제어 하기 위한 refs 제어
 * @hook
 */
const useSearchFilterRefs = (focus_category?: SEARCH_FILER_REF_TYPE | null) => {
  const { is_first_load_success } = useSearchFilter();

  const category_ref = useRef<HTMLElement>(null);
  const color_ref = useRef<HTMLElement>(null);
  const price_ref = useRef<HTMLElement>(null);
  const delivery_ref = useRef<HTMLElement>(null);

  const search_filter_refs = useMemo(
    () => ({
      [SEARCH_FILER_REF_TYPE.CATEGORY]: category_ref,
      [SEARCH_FILER_REF_TYPE.COLOR]: color_ref,
      [SEARCH_FILER_REF_TYPE.PRICE]: price_ref,
      [SEARCH_FILER_REF_TYPE.DELIVERY]: delivery_ref,
    }),
    [category_ref, color_ref, price_ref],
  );

  const moveSearchFilterSection = useCallback(
    (section_type: SEARCH_FILER_REF_TYPE) => {
      search_filter_refs[section_type].current?.scrollIntoView({ behavior: 'smooth' });
    },
    [search_filter_refs],
  );

  // MEMO: 검색필터 데이터 load 되고 보여주는 최초 진입 시점 해당 섹션(ex, 색상, 가격 쪽)으로 포커스 스크롤 처리 위함
  useEffect(() => {
    const is_move_first_load_focus = is_first_load_success && focus_category;

    if (is_move_first_load_focus) {
      moveSearchFilterSection(focus_category);
    }
  }, [is_first_load_success, moveSearchFilterSection, focus_category]);

  return {
    category_ref,
    color_ref,
    price_ref,
    delivery_ref,
    moveSearchFilterSection,
  };
};

export default useSearchFilterRefs;
